export default "__VITE_ASSET__1bf2f2e9__"